module.exports = __webpack_public_path__ + "static/fundacao_rio_verde_logo-7e0ac2a3f68bb7d7c233adb8050c9aab.png";